import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export class FeatureFlagResponse {
  enabled: boolean;
}

export interface FeatureFlagApiResponse {
  data: FeatureFlagResponse;
}

const FEATURE_ENABLED_URL = '/api/v1/is-feature-enabled/';

@Injectable()
export class FeatureFlagService {
  private featureEnabledLoading$$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private featureEnabledError$$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(private http: HttpClient) {
    this.featureEnabledLoading$$.next(false);
    this.featureEnabledError$$.next(false);
  }

  get featureEnabledLoading$(): Observable<boolean> {
    return this.featureEnabledLoading$$.asObservable();
  }

  get featureEnabledError$(): Observable<boolean> {
    return this.featureEnabledError$$.asObservable();
  }

  isFeatureEnabled(partnerId: string, featureId: string, marketId?: string): Observable<boolean> {
    // For local run, feature flag is always set to be on
    if (window.location.hostname === 'localhost') {
      return of(true);
    }
    this.featureEnabledLoading$$.next(true);
    this.featureEnabledError$$.next(false);

    const params = new HttpParams().set('partner_id', partnerId).set('feature_id', featureId);
    if (marketId) {
      params.set('market_id', marketId);
    }

    return this.http.get(FEATURE_ENABLED_URL, { params }).pipe(
      map((resp: FeatureFlagApiResponse) => {
        this.featureEnabledLoading$$.next(false);
        return resp.data.enabled;
      }),
      catchError(() => {
        this.featureEnabledLoading$$.next(false);
        this.featureEnabledError$$.next(true);
        return of(null);
      }),
    );
  }
}
